import { getCarbonFluxRepository } from "../Infrastructure/CarbonFlux.repository";
import { saveListCarbonFlux, saveCountCarbonFlux } from "../Infrastructure/CarbonFlux.store";

export async function getCarbonFlux(params) {
  const { count, resources: carbonFluxData } = await getCarbonFluxRepository(params);
  saveListCarbonFlux(carbonFluxData);
  saveCountCarbonFlux(count);
}